<template>
    <div class="check-step-item check-step-item-2"
         :class="{'check-step-item-done' : passedStep, 'expand' : expand && passedStep && !newStep}">
        <SubscribeCancelWindow @confirmCancel="confirmCancel"/>
        <SaveWindow text="Данные успешно сохранены"/>
        <div class="step-heading" @click="expand = !expand">
            <div v-if="passedStep" class="step-checked-icon">
                <DoneIcon/>
            </div>
            <div class="step-number">Шаг 2</div>
            <div class="step-title">Связаться с контактными лицами Клиента</div>
        </div>
        <div class="step-content">
            <div class="step-desc">
                Попробуйте выйти на&nbsp;связь с&nbsp;контактными лицами Клиента по&nbsp;любому из&nbsp;указанных им&nbsp;каналов
                связи
            </div>

            <div class="step-checklist">

                <div v-for="step in steps"
                     class="step-checklist-item"
                     :class="{'step-checklist-done': step.passed || passedStep}"
                >
                    <div class="step-checklist-text">Неделя {{ step.weekNumber }}. Удалось выяснить статус клиента?
                    </div>

                    <div class="step-checklist-row step-checklist-row-1">
                        <div class="step-checklist-field">
                            <label @click="showCallAfter = false" class="step-check-no">
                                <span class="field-radio-wrapper">
                                    <input v-model="step.contactResult"
                                           value="unsuccessful"
                                           type="radio"
                                           :disabled="step.passed || passedStep"
                                    >
                                    <span class="field-radio"></span>
                                </span>
                                <span>Не удалось связаться с контактными лицами</span>
                            </label>
                        </div>
                        <div class="step-checklist-field">
                            <label @click="stepSuccess(step)" class="step-check-yes">
                                <span class="field-radio-wrapper">
                                    <input v-model="step.contactResult"
                                           value="success"
                                           type="radio"
                                           :disabled="step.passed || passedStep"
                                    >
                                    <span class="field-radio"></span>
                                </span>
                                <span>Клиент жив</span>
                            </label>
                        </div>
                        <div class="step-checklist-field">
                            <label @click="showCallAfter = false" class="step-check-no">
                                <span class="field-radio-wrapper">
                                    <input v-model="step.contactResult"
                                           value="dead"
                                           type="radio"
                                           :disabled="step.passed || passedStep"
                                    >
                                    <span class="field-radio"></span>
                                </span>
                                <span>Клиент умер</span>
                            </label>
                        </div>
                    </div>

                    <div v-if="!step.passed && steps.indexOf(step) === steps.length - 1"
                         class="step-checklist-action">

                        <div v-if="showCallAfter" class="step-checklist-action-yes">
                            <div class="action-cell action-field">
                                <div class="form-field-input-2">
                                    <label>
                                        Перезвонить через, дней
                                    </label>
                                    <div class="field-input-wrapper">
                                        <input v-model="callAfterDays" @keypress="isNumber" type="text" required="" value="">
                                    </div>
                                </div>
                            </div>
                            <div class="action-cell action-divider">
                                ИЛИ
                            </div>
                            <div class="action-cell action-button">
                                <button @click="cancelSubscription"
                                        class="button button-dark modal-client-check-subscribe-cancel">
                                    Отменить подписку
                                </button>
                            </div>
                        </div>
                        <div v-if="step.weekNumber === 8 && step.contactResult === 'unsuccessful'"
                             class="step-checklist-action-yes step-checklist-action-yes-2">
                            <div class="action-cell action-button">
                                <button @click="cancelSubscription"
                                        class="button button-dark modal-client-check-subscribe-cancel">Отменить подписку
                                </button>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <div v-if="!passedStep" class="button-block">
                <button @click="save"
                        class="button button-dark"
                        :disabled="(showCallAfter === true && callAfterDays === '' && !removeSubscribe) || (passedStep)"
                >Сохранить
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import rest from "@/restUtils";
import SubscribeCancelWindow from "@/components/windows/SubscribeCancelWindow";
import SaveWindow from "@/components/windows/SaveWindow";
import DoneIcon from "@/components/icons/DoneIcon";

export default {
    name: "SecondStep",
    components: {DoneIcon, SaveWindow, SubscribeCancelWindow},
    props: ['steps', 'passed'],
    data() {
        return {
            showCallAfter: false,
            callAfterDays: '',
            isDead: false,
            removeSubscribe: false,
            passedStep: this.passed,
            expand: false,
            newStep: false
        }
    },

    created() {
        if (this.steps.length === 0) {
            this.steps.push({
                stepNumber: 1,
                weekNumber: 1,
                contactResult: 'unsuccessful',
                passed: false
            });
            this.newStep = true;
        }
    },

    watch: {
        steps() {
            if (this.steps.length === 0) {
                this.steps.push({
                    stepNumber: 1,
                    weekNumber: 1,
                    contactResult: 'unsuccessful',
                    passed: false
                });
                this.newStep = true;
            }
        },
        passed() {
            this.passedStep = this.passed
        }
    },

    methods: {
        stepSuccess(step) {
            if (!step.passed) {
                this.showCallAfter = true;
            }
        },
        async save() {
            let lastStep = this.steps[this.steps.length - 1];
            let dto = {
                step: {
                    id: lastStep.id,
                    stepNumber: 2,
                    weekNumber: lastStep.weekNumber,
                    contactResult: lastStep.contactResult
                },
                dead: lastStep.contactResult === 'dead',
                callAfterDays: this.callAfterDays,
                stepNumber: 2
            };

            try {
                let result = await rest.doPost("/admin/client/" + this.$route.query.id + "/step", dto);
                lastStep.id = result.savedId;
                if (result.currentStep !== 2) {
                    this.passedStep = true;
                    this.$emit("stepChanged", result.currentStep);
                }

                $('.window-wrapper.window-save-contacts').addClass('window-open');
                $('body').addClass('blocked');
            } catch (error) {

            }
        },
        cancelSubscription() {
            $('.window-wrapper.window-client-check-subscribe-cancel').addClass('window-open');
            $('body').addClass('blocked');
        },
        async confirmCancel() {
            this.removeSubscribe = true;
            try {
                await rest.doPost("/admin/client/" + this.$route.query.id + "/cancelSubscription");
                this.$emit('stepChanged', 0);
            } catch (error) {

            }
        },
        isNumber(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    }
}
</script>

<style scoped>

</style>